import type { EntityData, SectionStatus } from '../../types/canvas';
import { StatusDot } from './StatusDot';
import { ActionBar } from './ActionBar';

interface EntityCardProps {
  data: EntityData;
  status: SectionStatus;
  roleLabel?: string;
  onApprove?: () => void;
  onRefine?: () => void;
  onAnother?: () => void;
  refineDisabled?: boolean;
}

export function EntityCard({ data, status, roleLabel, onApprove, onRefine, onAnother, refineDisabled }: EntityCardProps) {
  const isIncomplete = !data.name || data.name === 'Unknown';

  return (
    <div className={`bg-surface border rounded-lg p-[18px] sm:px-[22px] cursor-pointer transition-colors duration-[150ms] hover:border-muted-foreground ${isIncomplete ? 'border-dashed border-border' : 'border-border'}`}>
      <div className="flex items-start gap-3 mb-2.5">
        <div className="w-10 h-10 rounded-full bg-background border border-border flex items-center justify-center font-display text-sm italic text-muted-foreground flex-shrink-0">
          {data.monogram || '?'}
        </div>
        <div className="min-w-0">
          <div className="text-[15px] font-semibold text-foreground">{data.name || 'Unknown'}</div>
          <div className="text-[11px] text-placeholder mt-px">
            {roleLabel ?? data.role}{data.age ? ` · ${data.age}` : ''}
          </div>
        </div>
        <div className="ml-auto">
          <StatusDot status={status} />
        </div>
      </div>

      {data.wound && (
        <div className="mt-3.5 border-t border-border pt-3 grid grid-cols-2 gap-2.5">
          <div>
            <div className="text-[10px] font-semibold tracking-wider uppercase text-placeholder mb-0.5">Wound</div>
            <div className="font-display text-[13px] italic text-foreground leading-snug [font-variation-settings:'opsz'_48,'SOFT'_80]">{data.wound}</div>
          </div>
          <div>
            <div className="text-[10px] font-semibold tracking-wider uppercase text-placeholder mb-0.5">Want</div>
            <div className="font-display text-[13px] italic text-foreground leading-snug [font-variation-settings:'opsz'_48,'SOFT'_80]">{data.want}</div>
          </div>
          <div>
            <div className="text-[10px] font-semibold tracking-wider uppercase text-placeholder mb-0.5">Need</div>
            <div className="font-display text-[13px] italic text-foreground leading-snug [font-variation-settings:'opsz'_48,'SOFT'_80]">{data.need}</div>
          </div>
          <div>
            <div className="text-[10px] font-semibold tracking-wider uppercase text-placeholder mb-0.5">Arc</div>
            <div className="font-display text-[13px] italic text-foreground leading-snug [font-variation-settings:'opsz'_48,'SOFT'_80]">{data.arc}</div>
          </div>
        </div>
      )}

      <ActionBar status={status} onApprove={onApprove} onRefine={onRefine} onAnother={onAnother} refineDisabled={refineDisabled} />
    </div>
  );
}
